import { render, staticRenderFns } from "./PropertyMaintenanceSystemForm.vue?vue&type=template&id=05edc23e&scoped=true"
import script from "./PropertyMaintenanceSystemForm.vue?vue&type=script&lang=ts"
export * from "./PropertyMaintenanceSystemForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05edc23e",
  null
  
)

export default component.exports